import { Link } from "react-router-dom";
import { ROUTES } from "routes/routePaths";
import userAvatar from "assets/images/user-avatar.png";
import { Typography, AnchorMenu, Tag } from "components";
import { AiOutlineEye, AiFillEdit } from "react-icons/ai";
import { genderOptions, userStatuses } from "utils/constants";
import {
  capitalizeFirstLetter,
  formatDateTime,
  getDecodedToken,
  getAccessToken,
} from "utils/helper";

const user = getDecodedToken(getAccessToken());

const agentAnchorRender = (userInfo, userType) => {
  return (
    <ul className="py-1" style={{ paddingLeft: ".6rem" }}>
      <li>
        <Link
          to={ROUTES.viewUser}
          state={{ userInfo, userType }}
          style={{ textDecoration: "none" }}
        >
          <div className="d-flex align-items-center">
            <AiOutlineEye
              fontSize="14px"
              style={{ marginRight: ".5rem" }}
              color="#102E88"
            />
            <Typography state="primary" variant="caption1">
              View Profile
            </Typography>
          </div>
        </Link>
      </li>
      {/* {userType !== "admin" &&
        hasPermission(permissions.canUpdateAgent, user?.authorities) && (
          <li>
            <div className="d-flex align-items-center mt-1 cursor-pointer">
              <AiFillEdit
                fontSize="14px"
                style={{ marginRight: ".5rem" }}
                color="#102E88"
              />
              <Typography state="primary" variant="caption1">
                Edit User
              </Typography>
            </div>
          </li>
        )} */}

      {/* No updates unless user is active or disabled, ensuring you cannot edit yourself */}
      {userType === "admin" &&
        user?.user_id?.toString() !== userInfo?.id?.toString() &&
        userInfo.id !== ["0", "1"].includes(userInfo?.status?.toString()) && (
          <li className="mt-2">
            <Link
              to={ROUTES.createAdminUser}
              state={{ userInfo, userType }}
              style={{ textDecoration: "none" }}
            >
              <div className="d-flex align-items-center">
                <AiFillEdit
                  fontSize="14px"
                  style={{ marginRight: ".5rem" }}
                  color="#102E88"
                />
                <Typography state="primary" variant="caption1">
                  Edit Admin Profile
                </Typography>
              </div>
            </Link>
          </li>
        )}
    </ul>
  );
};

const getStatusTag = (value) => {
  let val = userStatuses.find((status) => status.value === value);
  return val ? (
    <Tag text={val.text} backgroundColor={val.bgColor} textColor={val.color} />
  ) : (
    ""
  );
};

const getAgentColumns = (pageNumber) => [
  {
    Header: "S/N",
    Cell: ({ row }) => {
      let sn = Number(row.id) + 1;

      return sn.toString().length === 1 ? "0" + sn : sn;
    },
  },
  {
    Header: "Image",
    Cell: (props) => <img src={userAvatar} alt="" height="45px" />,
  },
  {
    Header: "Corporate",
    Cell: ({ row }) => (row.original?.agentDetails?.isCorporate ? "Yes" : "No"),
  },
  {
    Header: "Name",
    Cell: ({ row }) => {
      if (row.original?.agentDetails?.isCorporate)
        return row.original?.agentDetails?.corporateName;

      return (
        capitalizeFirstLetter(row.original?.firstName) +
        " " +
        capitalizeFirstLetter(row.original?.lastName)
      );
    },
  },
  {
    Header: "Gender",
    accessor: "gender",
    Cell: ({ value }) =>
      value && genderOptions.find((gender) => gender.value === value)?.label,
  },
  {
    Header: "Agent Code",
    accessor: "agentDetails",
    Cell: ({ value }) => value?.agentCode || "Nil",
    customWidth: "7rem",
  },
  {
    Header: "Username",
    accessor: "username",
  },
  {
    Header: "NIN",
    accessor: "nin",
    Cell: ({ value }) => value || "Nil",
  },
  {
    Header: "PM Number",
    Cell: ({ row }) => {
      const pmNumbers = row.original?.agentDetails?.pmNumber;
      if (!pmNumbers?.length) return "Nil";

      if (pmNumbers?.length === 1) return pmNumbers[0];

      return pmNumbers?.map(
        (pmNumber, i) =>
          `${pmNumber}${i === pmNumbers?.length - 1 ? "." : ","} `
      );
    },
  },
  {
    Header: "Aggregator Code",
    Cell: ({ row }) => {
      return row.original?.agentDetails?.parentCode || "Nil";
    },
  },
  // {
  //   Header: "Terminals",
  //   accessor: "terminals",
  //   Cell: () => "-",
  // },
  {
    Header: "Date Registered",
    accessor: "createdDate",
    Cell: ({ value }) => formatDateTime(value),
    customWidth: "8rem",
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => getStatusTag(value),
    customWidth: "10rem",
  },
  {
    Header: "Action",
    Cell: (props) => (
      <AnchorMenu
        anchorRender={() => agentAnchorRender(props.row?.original, "agent")}
      />
    ),
  },
];

const getAggregatorColumns = (pageNumber) => [
  {
    Header: "S/N",
    Cell: (row) => {
      let sn = Number(row.row.id) + 1;
      return sn.toString().length === 1 ? "0" + sn : sn;
    },
  },
  {
    Header: "Image",
    Cell: (props) => <img src={userAvatar} alt="" height="45px" />,
  },
  {
    Header: "Corporate",
    Cell: ({ row }) => (row.original?.agentDetails?.isCorporate ? "Yes" : "No"),
  },
  {
    Header: "Name",
    Cell: ({ row }) => {
      if (row.original?.agentDetails?.isCorporate)
        return row.original?.agentDetails?.corporateName;

      return (
        capitalizeFirstLetter(row.original?.firstName) +
        " " +
        capitalizeFirstLetter(row.original?.lastName)
      );
    },
  },
  {
    Header: "Gender",
    accessor: "gender",
    Cell: ({ value }) =>
      value && genderOptions.find((gender) => gender.value === value)?.label,
  },
  {
    Header: "Aggregator Code",
    accessor: "agentDetails",
    Cell: ({ value }) => value?.agentCode || "Nil",
    customWidth: "7rem",
  },
  {
    Header: "Username",
    accessor: "username",
  },
  {
    Header: "NIN",
    accessor: "nin",
    Cell: ({ value }) => value || "Nil",
  },
  {
    Header: "PM Number",
    Cell: ({ row }) => {
      const pmNumbers = row.original?.agentDetails?.pmNumber;
      if (!pmNumbers?.length) return "Nil";

      if (pmNumbers?.length === 1) return pmNumbers[0];

      return pmNumbers?.map(
        (pmNumber, i) =>
          `${pmNumber}${i === pmNumbers?.length - 1 ? "." : ","} `
      );
    },
  },
  // {
  //   Header: "Terminals",
  //   accessor: "terminals",
  //   Cell: () => "-",
  // },
  {
    Header: "Date Registered",
    accessor: "createdDate",
    Cell: ({ value }) => formatDateTime(value),
    customWidth: "8rem",
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => getStatusTag(value),
    customWidth: "10rem",
  },
  {
    Header: "Action",
    Cell: (props) => (
      <AnchorMenu
        anchorRender={() => agentAnchorRender(props.row.original, "aggregator")}
      />
    ),
  },
];

const getAdminColumns = (pageNumber) => [
  {
    Header: "S/N",
    Cell: (row) => {
      let sn = Number(row.row.id) + 1;
      return sn.toString().length === 1 ? "0" + sn : sn;
    },
  },
  {
    Header: "Image",
    Cell: (props) => <img src={userAvatar} alt="" height="45px" />,
  },
  {
    Header: "Name",
    Cell: ({ row }) => {
      return (
        capitalizeFirstLetter(row.original.firstName) +
        " " +
        capitalizeFirstLetter(row.original.lastName)
      );
    },
  },
  {
    Header: "Gender",
    accessor: "gender",
    Cell: ({ value }) =>
      value && genderOptions.find((gender) => gender.value === value)?.label,
  },
  {
    Header: "Role",
    accessor: "roles",
    Cell: ({ value }) => (value?.length ? capitalizeFirstLetter(value[0]) : ""),
  },
  {
    Header: "Username",
    accessor: "username",
  },
  {
    Header: "Date Registered",
    accessor: "createdDate",
    Cell: ({ value }) => formatDateTime(value),
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => getStatusTag(value),
    customWidth: "10rem",
  },
  {
    Header: "Action",
    Cell: (props) => (
      <AnchorMenu
        anchorRender={() => agentAnchorRender(props.row.original, "admin")}
      />
    ),
  },
];

export { getAgentColumns, getAggregatorColumns, getAdminColumns };
